import React from "react";
import "./Component_1.css";

const Component_1 = ({ topDescn, title, subtitle, features, imgSrc }) => {
  return (
    <div className="Component_1">
      <div className="main_content">
        <p className="top_descn">{topDescn}</p>
      </div>

      <div className="features_main_div">
        <div className="row">
          <div className="col-lg-6">
            <div className="common_left_div">
              <h2 className="div_title">{title}</h2>
              <p className="div_subtitle">{subtitle}</p>

              <div className="all_features_div">
                {features?.map((item) => {
                  return (
                    <div className="feature_div">
                      <p className="label_text">{item?.label}</p>
                      <p className="value_text">{item?.value}</p>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="feature_img">
              {imgSrc && (
                <img src={imgSrc} alt={title} className="feature_image" />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Component_1;
